export const resolveLoadTypeFromLeg = (leg: any): string => {
  const operationTypes = [
    leg?.loadType,
    leg?.operationType,
    leg?.carDetails?.operationType,
    leg?.trailerDetails?.operationType,
  ];
  const type = operationTypes.find(
    (value) => String(value ?? '').trim().length > 0,
  );

  if (type) {
    if (String(type).trim().toLowerCase() === 'checkpoint') {
      return 'Checkpoint';
    }
    return String(type).trim();
  }

  if (leg?.load && leg?.unload) return 'Load/Unload';
  if (leg?.load) return 'Load';
  if (leg?.unload) return 'Unload';
  return 'Checkpoint';
};
